import React from 'react';
import { Box, Typography } from '@mui/material';

const FolderCard = ({ title, subtitle, onClick, variant = 'year' }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
      marginTop:'16px',
        cursor: 'pointer',
        p: 3,
        borderRadius: '16px',
        position: 'relative',
        bgcolor:
          variant === 'year'
            ? '#e3f2fd'
            : variant === 'month'
            ? '#ede7f6'
            : '#f1f8e9',
        boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
        transition: 'all 0.25s ease',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: '0 12px 28px rgba(0,0,0,0.15)',
        },
      }}
    >
      {/* Folder Tab */}
      {variant !== 'week' && (
        <Box
          sx={{
            position: 'absolute',
            top: '-12px',
            left: '16px',
            width: '70px',
            height: '14px',
            bgcolor: 'rgba(0,0,0,0.15)',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        />
      )}

      <Typography
        variant={variant === 'year' ? 'h4' : 'h6'}
        fontWeight={600}
      >
        {title}
      </Typography>

      {subtitle && (
        <Typography variant="body2" sx={{ mt: 1, opacity: 0.7 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default FolderCard;
